document.addEventListener('DOMContentLoaded', function() {
  function handleSectionVisibility() {
    // Find all banners with our visibility attribute
    const banners = document.querySelectorAll('[data-banner-visibility]');
    
    banners.forEach(banner => {
      // Get the parent section element
      const parentSection = banner.closest('.shopify-section');
      if (!parentSection) return;

      const visibility = banner.getAttribute('data-banner-visibility');
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      // Set display on the parent section element
      if ((visibility === 'desktop' && isMobile) || 
          (visibility === 'mobile' && !isMobile)) {
        parentSection.style.display = 'none';
      } else {
        parentSection.style.display = 'block';
      }
    });
  }

  // Initial check
  handleSectionVisibility();

  // Check on resize
  window.addEventListener('resize', () => {
    handleSectionVisibility();
  });
}); 